<template>
   <v-speed-dial
      v-model="status"
      top
      right
      absolute
    >
      <template v-slot:activator>
        <v-btn
          color="grey darken-3"
          dark
          fab
          @click="onClick"
          v-if="back"
        >
         <x-icon size="2x" class=""/>
        </v-btn>
      </template>
   </v-speed-dial>
</template>

<script>
import { mapGetters } from 'vuex'

import utility from '@/mixins/utility'

import { XIcon } from 'vue-feather-icons'

export default {
   name: 'Back',

   mixins: [ utility ],
   
   components: 
   {
      XIcon
   },

   data: () => ({
      status: false
   }),

   computed:
   {
      ...mapGetters({
         back: 'ui/back'
      }),
   },

   methods:
   {
      onClick()
      {
         this.goTo(this.back)
      }
   },

   load(){}
}
</script>